import './css/styles.scss';

let isScrolling: number;

function throttle(func: () => void, limit: number) {
	let inThrottle: boolean;
	return function () {
		if (!inThrottle) {
			func();
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}
function initStickyHeader() {
	const header = document.querySelector('header.wp-block-template-part') as HTMLElement;
	if (!header) return;

	let headerOffset = header.offsetHeight;

	const adminBar = document.querySelector('#wpadminbar') as HTMLElement;
	if (adminBar) {
		headerOffset += adminBar.offsetHeight;
	}
	//console.log('initStickyHeader');
	//console.log(headerOffset);

	let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

	const windowScroll = window.scrollY || window.pageYOffset;

	const threshold = 4; // Adjust this value to your needs

	if (currentScroll >= threshold) {
		header.classList.add('fixed-header');
	} else {
		header.classList.remove('fixed-header');
	}
}


const throttledInitStickyHeader = throttle(initStickyHeader, 25);

window.addEventListener('load', function () {
	throttledInitStickyHeader();
	window.addEventListener('resize', throttledInitStickyHeader);
	window.addEventListener('scroll', function () {
		// Clear our timeout throughout the scroll
		window.clearTimeout(isScrolling);

		// Set a timeout to run after scrolling ends
		isScrolling = setTimeout(function () {
			// Run the callback
			initStickyHeader();
		}, 66);

		// Call the throttled function for while scrolling
		throttledInitStickyHeader();
	});
});

// when dom is ready



function fixedPadding() {
	const header = document.querySelector('header');
	if (header) {
		/*const headerHeight = (header as HTMLElement).offsetHeight;
		const windowWidth = window.innerWidth;
		const heroSection = document.querySelector('section.hero-bildspel-section');
		const heroSectionSubPage = document.querySelector('section.is-style-subpage-hero');
		const kaksmulor = document.querySelector('.is-style-kaksmulor');
		if (heroSection) {
			(heroSection as HTMLElement).style.marginTop = `${headerHeight}px`;
		}
		if (heroSectionSubPage && windowWidth > 1280) {
			//(heroSectionSubPage as HTMLElement).style.marginTop = `${headerHeight}px`;
			(heroSectionSubPage as HTMLElement).style.marginTop = `16px`;
		}
		if (kaksmulor) {
			(kaksmulor as HTMLElement).style.marginTop = `${headerHeight}px`;
		}
		if (heroSectionSubPage && windowWidth < 1280) {
			const headerHeightNew = 16;
			(heroSectionSubPage as HTMLElement).style.marginTop = `${headerHeightNew}px`;
		}
		if (heroSectionSubPage && windowWidth < 600) {
			const headerHeightNew = 8;
			(heroSectionSubPage as HTMLElement).style.marginTop = `${headerHeightNew}px`;

		} */

	}
}

function initMenu() {
	const header = document.querySelector('header.wp-block-template-part');
	if (!header) return;
	const menuItems = header.querySelectorAll('.main-site-navigation .menu-item-has-children');
	let timeoutId;

	if (!menuItems) return;

	const overlay = header.querySelector('[data-menu-overlay]');

	menuItems.forEach((item) => {
		item.addEventListener('mouseover', function () {
			clearTimeout(timeoutId);
			header.classList.add('is-active');

			const background = header.querySelector('#header-bg-fix') as HTMLElement;
			if (!background) return;

			const headerHeight = header.offsetHeight;
			const subMenu = item.querySelector('.sub-menu') as HTMLElement | null;
			//let subMenuHeight = subMenu ? subMenu.offsetHeight : 0;
			let subMenuHeight = subMenu.acctuallyOffsetHeight || 0;
			

				console.group('MENU DEBUG');
				console.log('Header height:', headerHeight);
				console.log('Submenu height:', subMenuHeight);
				console.log('Total (background):', headerHeight + subMenuHeight);
				console.groupEnd();

			background.classList.remove('is-closing');

			// sätt första höjden (grundnivå)
			background.style.height = `${headerHeight}px`;

			// 🔥 tvinga reflow så transitioner fungerar
			void background.offsetHeight;

			// nu, nästa frame, sätt slutnivån
			requestAnimationFrame(() => {
				background.style.height = `${headerHeight + subMenuHeight}px`;
				background.style.minHeight = '210px';
			});

			timeoutId = setTimeout(() => item.classList.add('active'), 100);
		});

		item.addEventListener('mouseleave', function () {
			const background = header.querySelector('#header-bg-fix') as HTMLElement;
			if (!background) return;

			background.classList.add('is-closing');

			// 🔥 tvinga reflow
			void background.offsetHeight;

			requestAnimationFrame(() => {
				background.style.height = '0px';
				background.style.minHeight = '0px';
			});

			timeoutId = setTimeout(() => {
				header.classList.remove('is-active');
				item.classList.remove('active');
				background.classList.remove('is-closing');
			}, 600); // matcha transitionens längd
		});
	});
}

// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	fixedPadding();
	initMenu();
});
